import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {useTranslation} from '@/translations/i18n'
import {MedicalRecordSearchParams} from '@/features/medical-records/types'
import {useEffect, useState} from 'react'
import {UserSmall} from '@/features/users/types'
import {useGetUser} from '@/features/users/queries/useGetUser'
import {InputSelectUser} from '@/features/users/components/input-select-user/InputSelectUser'
import {StyledInputSelectOperatorWrapper} from './style'

export const MedicalRecordOperatorFilter = () => {
    const {t} = useTranslation()

    const {
        setSearchParams,
        searchParams: {createdByUserId: userParamId}
    } = useParsedSearchParams(MedicalRecordSearchParams)

    const [user, setUser] = useState<Pick<UserSmall, 'id' | 'fullName'> | null>(null)

    const {data: filteredUser} = useGetUser({
        userId: userParamId,
        responseType: 'small',
        options: {enabled: !!userParamId}
    })

    useEffect(() => {
        if (filteredUser) {
            setUser(filteredUser)
        }
    }, [filteredUser, userParamId])

    return (
        <StyledInputSelectOperatorWrapper>
            <InputSelectUser
                placeholder={t('commons:operator')}
                value={userParamId && user ? user : null}
                onClear={() => {
                    setUser(null)
                    setSearchParams({createdByUserId: undefined})
                }}
                onChange={user => {
                    if (user) {
                        setUser(user)
                        setSearchParams({createdByUserId: user.id})
                    } else {
                        setUser(null)
                        setSearchParams({createdByUserId: undefined})
                    }
                }}
            />
        </StyledInputSelectOperatorWrapper>
    )
}
